import React from 'react';
import { Row, Col, Container } from 'reactstrap';
import { ReactComponent as NJRLogo } from '../../../assets/images/Vendor/NJR/njr-retail-logo.svg';
import { ReactComponent as AIGLogo } from '../../../assets/images/aig-logo.svg';
import NeedHelp from '../../modals/NeedHelp/NeedHelp';
import styles from './NJRFooter.module.css';
import NJRTermsDocument from '../../../assets/Documents/NJR/njr-serviceplan-terms.pdf';

export const NJRFooter = () => {
    return (
        <>
            {/* WHITE FOOTER WITH LOGOS  */}
            <Container
                className={styles.footer1}
                role='complementary'
            >
                <div className={styles.legal}>
                    NJR Retail Service Plans are offered, sold and issued by AIG WarrantyGuard, Inc., 650 Missouri
                    Avenue, Jeffersonville, IN 47130, an affiliate of American International Group, Inc. (AIG).
                    Limitations and exclusions apply. See the complete{' '}
                    <a
                        className={styles.link}
                        onClick={() => window.open(NJRTermsDocument)}
                    >
                        terms and conditions.
                    </a>{' '}
                    NJR Retail is not affiliated with AIG or any of its affiliates. NJR Retail trademarks used with
                    permission.
                </div>
                <div className={styles.njrLogo}>
                    <NJRLogo />
                </div>
                <div className={styles.aigLogoWithText}>
                    <p>Provided by</p>
                    <AIGLogo />
                </div>
            </Container>
            {/* BORING GRAY FOOTER  */}
            <footer aria-label='Footer'>
                <Container className={styles.footer2}>
                    <ul className={styles.footerNav}>
                        <li>
                            <a
                                href='https://www.aig.com/privacy-policy'
                                target='_blank'
                            >
                                {' '}
                                Privacy Policy
                            </a>
                        </li>
                        <li>
                            <a
                                href='https://www.aig.com/terms-of-use'
                                target='_blank'
                            >
                                {' '}
                                Terms of Use
                            </a>
                        </li>
                    </ul>

                    <p>Copyright &#169; {new Date().getFullYear()} NJR Retail. All rights reserved.</p>

                    <p>
                        NJR Retail is not the same company as New Jersey Natural Gas, the utility, and is not regulated
                        by the New Jersey Board of Public Utilities. You do not have to buy products or services from
                        NJR Retail in order to continue receiving regulated services from New Jersey Natural Gas.
                    </p>

                    <NeedHelp />
                </Container>
            </footer>
        </>
    );
};
